import { Pop } from "../../shared/utils/animations";
import type { HTMLAttributes } from "react";

interface BadgeProps extends HTMLAttributes<HTMLDivElement> {
  animation?: string;
}

const Badge = ({ animation, children, style, ...props }: BadgeProps) => {
  return (
    <div
      className="ml-4 inline-flex h-8 w-8 items-center justify-center rounded-full bg-error text-center text-white"
      style={{ animation: `${animation || Pop} 0.3s ease`, ...style }}
      {...props}
    >
      {children || "!"}
    </div>
  );
};

export default Badge;
